// src/components/calendar/CalendarDay.jsx
import React, { useCallback } from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import { Add as PlusIcon } from '@mui/icons-material';
import EventItem from './EventItem';

const CalendarDay = React.memo(({ day, events, onDrop, onAddClick, onDragStart, onEventClick, isOutsideMonth }) => {
    const handleDragOver = useCallback((e) => {
        e.preventDefault();
    }, []);

    const handleDrop = useCallback(() => {
        onDrop(day);
    }, [onDrop, day]);

    return (
        <Paper
            elevation={1}
            sx={{
                height: '110px',
                border: '1px solid #e0e0e0',
                p: 1,
                position: 'relative',
                opacity: isOutsideMonth ? 0.6 : 1,
                backgroundColor: isOutsideMonth ? '#f9f9f9' : '#fff',
            }}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Typography variant="body2" color={isOutsideMonth ? 'text.secondary' : 'text.primary'}>
                    {day.getDate()}
                </Typography>
                {!isOutsideMonth && (
                    <Button
                        variant="text"
                        size="small"
                        sx={{ minWidth: '24px', height: '24px', p: 0 }}
                        onClick={() => onAddClick(day)}
                    >
                        <PlusIcon fontSize="small" />
                    </Button>
                )}
            </Box>
            <Box sx={{ marginTop: '8px', overflowY: 'auto', maxHeight: '80px' }}>
                {events.map((event) => (
                    <EventItem
                        key={event.id}
                        event={event}
                        onDragStart={onDragStart}
                        onEventClick={onEventClick}
                    />
                ))}
            </Box>
        </Paper>
    );
});

export default CalendarDay;
